import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { BackgroundPanel } from "./BackgroundPanel";
import { ColoursPanel } from "./ColoursPanel";
import { PhotoPanel } from "./PhotoPanel";
import { DetailsPanel } from "./DetailsPanel";
import { CrestFlagPanel } from "./CrestFlagPanel";
import { StatsPanel } from "./StatsPanel";
import { SizePanel } from "./SizePanel";

const SECTIONS = [
  ["background", "Background style"],
  ["colours", "Club colours"],
  ["photo", "Player photograph"],
  ["details", "Player details"],
  ["crest", "Club crest & flag"],
  ["stats", "Player statistics"],
  ["size", "Shield size"],
];

export const NextButton = ({ label, onClick }) => (
  <button type="button" onClick={onClick} className="mt-5 flex w-full items-center justify-center gap-2 bg-slate-900 py-3 text-sm font-bold uppercase text-lime-300" data-testid="mobile-next-button">
    Next: {label} <ArrowRight className="h-4 w-4" />
  </button>
);

export const ControlSections = ({ design, set, tab, next }) => {
  const [open, setOpen] = useState(() => (window.matchMedia("(min-width: 1024px)").matches ? SECTIONS.map(([k]) => k) : ["background"]));
  const body = {
    background: <BackgroundPanel background={design.background} colours={design.colours} onChange={set("background")} />,
    colours: <ColoursPanel colours={design.colours} onChange={set("colours")} textPanel={design.textPanel !== false} onTextPanel={set("textPanel")} />,
    photo: <PhotoPanel photo={design.photo} onChange={set("photo")} />,
    details: <DetailsPanel player={design.player} sport={design.sport} accent={design.colours.accent} onChange={set("player")} />,
    crest: <CrestFlagPanel sport={design.sport} crest={design.crest} flag={design.flag} onCrest={set("crest")} onFlag={set("flag")} />,
    stats: <StatsPanel stats={design.stats} sport={design.sport} onChange={set("stats")} />,
    size: <SizePanel size={design.size} design={design} onChange={set("size")} />,
  };
  if (tab) {
    const i = SECTIONS.findIndex(([k]) => k === tab);
    return (
      <div key={tab} className="fade-up border-2 border-slate-900 bg-white p-4" data-testid={`section-${tab}`}>
        <h2 className="font-display mb-3 text-base font-extrabold uppercase tracking-tight">{SECTIONS[i][1]}</h2>
        {body[tab]}
        {next}
      </div>
    );
  }
  return (
    <Accordion type="multiple" value={open} onValueChange={setOpen} className="space-y-3">
      {SECTIONS.map(([k, label], i) => (
        <AccordionItem key={k} value={k} className="fade-up border-2 border-slate-200 bg-white px-4 data-[state=open]:border-slate-900" style={{ animationDelay: `${i * 60}ms` }} data-testid={`section-${k}`}>
          <AccordionTrigger className="py-4 hover:no-underline" data-testid={`section-${k}-toggle`}>
            <span className="flex items-center gap-3">
              <span className="font-cond flex h-7 w-7 items-center justify-center bg-slate-900 text-base font-bold text-lime-300">{i + 1}</span>
              <span className="font-display text-base font-extrabold uppercase tracking-tight sm:text-lg">{label}</span>
            </span>
          </AccordionTrigger>
          <AccordionContent className="pb-5 pt-1">{body[k]}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
